<template>
  <span
    v-tooltip="tooltip ? tooltipOptions : null"
    class="info-tag"
    :class="[{ 'info-tag--tooltip': tooltip }, `info-tag--${colour}`]"
  >
    {{ tag }}
  </span>
</template>

<script>
export default {
  name: 'InfoTag',
  props: {
    tooltip: {
      type: String,
      default: null,
    },
    tag: {
      type: String,
      required: true,
    },
    colour: {
      type: String,
      default: 'purple',
      validator: (value) => {
        return ['purple', 'red', 'green', 'blue'].includes(value)
      },
    },
  },
  computed: {
    tooltipOptions() {
      return {
        maxWidth: 300,
        content: this.tooltip || null,
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.info-tag {
  background: lighten($dark-grey, 70);
  margin-right: 1em;
  padding: 0.5em 0.8em;
  border: 1px solid $dark-grey;
  border-radius: 3px;
  font-size: $tiny-font;
  font-weight: 600;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: $dark-grey;
  &--purple {
    color: $purple;
    border-color: $purple;
    background-color: lighten($purple, 30);
  }
  &--green {
    color: $green;
    border-color: $green;
    background-color: lighten($green, 45);
  }
  &--blue {
    color: $blue;
    border-color: $blue;
    background-color: lighten($blue, 30);
  }
  &--red {
    color: $red;
    border-color: $red;
    background-color: lighten($red, 40);
  }
  &--tooltip {
    &:hover {
      cursor: help;
    }
  }
}
</style>
